import { withApollo } from "react-apollo";
import React from "react";
import Pagination from "../../Common/Pagination";
import { withRouter } from "react-router-dom";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
// import { redirectTo } from "../../../util/redirect";
import { roles } from "../../../services/graphql/queries/roles";
import NotAccessible from "../../Common/NotAccessible";
import ReactModal from "../../Common/ReactModal";
import { DESCRIPTION_MAX_LENGTH } from "../../../constants/app-constants";
import view from "../../../static/images/svg/view.svg";
class RolesList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilter: false,
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      loading: false,
      errors: [],
      error: "",
      accessSpecifier: {},
      accessSpecifierLoading: true,
      Roles_Feature_ID: 172,
      Roles_Module_ID: 6,
      requireCancel: false,
      modalMessage: "You dont have permission to do this Action"
    };

    this.onAddUser = this.onAddUser.bind(this);
    this.getRoles = this.getRoles.bind(this);
    this.fetchAccessSpecifier = this.fetchAccessSpecifier.bind(this);
    this.submitModal = this.submitModal.bind(this);
  }

  onAddUser() {
    if (this.state.accessSpecifier.createP) {
      // redirectTo("/roles-add");
      this.props.history.push("/roles-add");
    } else {
      this.setState({ reactModalVisible: true });
    }
  }

  onViewUser(id) {
    // redirectTo("/roles-profile?id=" + id);
    this.props.history.push("/roles-profile?id=" + id);
  }
  submitModal() {
    this.setState({ reactModalVisible: false });
  }
  onChangePage(currentPage) {
    // update state with new page of items
    this.setState(
      {
        currentPage: currentPage
      },
      () => {
        this.getRoles();
      }
    );
  }
  getRoles() {
    this.setState({ loading: true });

    this.props.client
      .query({
        query: roles,
        variables: {
          offset: this.state.offset,
          pageNo: this.state.currentPage
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        const user = result.data.roles;

        this.initialState = {
          pageOfItems: user
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.roles);
      })
      .catch(error => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }
  fetchAccessSpecifier() {
    this.setState({
      loading: true
    });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.Roles_Module_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState({
            accessSpecifier: response[this.state.Roles_Feature_ID],
            accessSpecifierLoading: false
          });
          this.getRoles();
        } else {
          this.setState({
            accessSpecifierLoading: false
          });
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message,
          accessSpecifierLoading: false
        });
      });
  }
  componentDidMount() {
    this.fetchAccessSpecifier();
    // this.getRoles();
  }

  render() {
    const {
      loading,
      error,
      accessSpecifierLoading,
      accessSpecifier,
      reactModalVisible,
      requireCancel,
      modalMessage
    } = this.state;
    const users = this.state.pageOfItems;

    // if (error) return <div>Error !!!</div>;
    // if (loading) return <div>Fetching...</div>;
    return (
      <div>
        {accessSpecifier && accessSpecifier.viewP ? (
          <>
            <ReactModal
              reactModalVisible={reactModalVisible}
              submitModal={this.submitModal}
              modalMessage={modalMessage}
              requireCancel={requireCancel}
            />
            <div className="row align-items-center no-gutters">
              <div className="col-md-9">
                <h1 className="heading m-b-0">Roles List View</h1>
              </div>
              <div className="col-md-3 text-right">
                <button className="btn btn-danger" onClick={this.onAddUser}>
                  Add Role
                </button>
              </div>
            </div>
            <table className="table table-style-1">
              <thead>
                <tr>
                  {/* <th>ID</th> */}
                  <th>ROLE NAME</th>
                  <th>DESCRIPTION</th>
                  <th>ENTITY TYPE</th>
                  <th>ACTION(s)</th>
                </tr>
              </thead>
              <tbody>
                {users.length
                  ? users.map((data, index) => {
                      return (
                        <tr key={index}>
                          {/* <td>{data.Id}</td> */}
                          <td>{data.roleName}</td>
                          <td>
                            {data.description.substring(
                              0,
                              DESCRIPTION_MAX_LENGTH
                            )}
                          </td>
                          <td>
                            {data.entityType == 2
                              ? " User"
                              : data.entityType == 1
                              ? " Investor"
                              : ""}
                          </td>
                          <td>
                            <a
                              href="#"
                              className="link-primary"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="View"
                              onClick={this.onViewUser.bind(this, data.Id)}
                            >
                              {/* <img src={view} /> */}
                              <svg
                                  x="0px"
                                  y="0px"
                                  width="16px"
                                  height="16px"
                                  viewBox="0 0 16 16"
                                >
                                  <g transform="translate(0, 0)">
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="11.5"
                                      x2="11.5"
                                      y2="11.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="8.5"
                                      x2="11.5"
                                      y2="8.5"
                                      data-color="color-2"
                                    />
                                    <line
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      x1="4.5"
                                      y1="5.5"
                                      x2="6.5"
                                      y2="5.5"
                                      data-color="color-2"
                                    />
                                    <polygon
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 1.5,0.5 1.5,15.5 14.5,15.5 14.5,5.5 "
                                    />
                                    <polyline
                                      fill="none"
                                      stroke="#69951a"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeMiterlimit={10}
                                      points="9.5,0.5 9.5,5.5 14.5,5.5 "
                                    />
                                  </g>
                                </svg>
                            </a>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
            {!users.length && error ? <div>{error}</div> : null}
            {!users.length && loading ? <div>Fetching...</div> : null}
            {!users.length && !error && !loading ? (
              <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            {/* <Pagination
              loading={loading}
              items={users}
              pageSize={this.state.offset}
              initialPage={this.state.currentPage}
              onChangePage={this.onChangePage.bind(this)}
            /> */}
          </>
        ) : accessSpecifierLoading ? (
          <div>Fetching...</div>
        ) : (
          <NotAccessible />
        )}
      </div>
    );
  }
}
export default withRouter(withApollo(RolesList));
